module.exports = __webpack_public_path__ + "img/master-visaul-mobile.1c5e2a7c.png";